import React from 'react';
import PropTypes from 'prop-types';
import ButtonBraun from '../../../common/ButtonBraun';
import styles from './styles.module.css';

const DiscoverComponent = ({
  className,
  title,
  subTitle,
  elements,
}) => {

  const clickDiscover = (url) => {
    if (typeof window !== `undefined`) {
      window.open(url, '_blank');
    }
  };

  return (
    <>
      <div
        className={`${className} ${styles.discoversWrapper}`}>
        {/* title */}
        {title && subTitle &&
        <div className={styles.discoverMainMessage}>
          <div dangerouslySetInnerHTML={{ __html: title }} />
          <div dangerouslySetInnerHTML={{ __html: subTitle }} />
        </div>}
        {/* element list */}
        <div className={styles.discoverElementList}>
          {elements && elements.map((element, index) => {
            return (
              <div
                className={styles.discoverElement}
                key={index}>
                {/* element image */}
                {element?.image && <div className={styles.discoverImage}>
                  <img src={element.image} alt="" />
                </div>}
                {/* element button */}
                {element?.url &&
                <ButtonBraun
                  text={element?.btnText}
                  theme="dark"
                  onClickEvent={(e) => clickDiscover(element.url)}
                />}
                {/* timeline icon */}
                <div
                  className={styles.discoverTimelineIcon}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
                    <g id="Layer_2" data-name="Layer 2">
                      <g id="Layer_1-2" data-name="Layer 1">
                        <path id="Layer0_36_MEMBER_1_1_STROKES" data-name="Layer0 36 MEMBER 1 1 STROKES" d="M9.53,9.54A4.82,4.82,0,0,1,6,11,4.82,4.82,0,0,1,2.47,9.54,4.83,4.83,0,0,1,1,6,4.82,4.82,0,0,1,2.46,2.47,4.83,4.83,0,0,1,6,1,4.83,4.83,0,0,1,9.54,2.47,4.82,4.82,0,0,1,11,6,4.83,4.83,0,0,1,9.53,9.54Z"
                          style={{ fill: "none", stroke: "#000", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2px" }} />
                      </g>
                    </g>
                  </svg>
                </div>
                {/* timeline texts */}
                <div className={styles.nameAndDescription}>
                  {element?.name && <div className={styles.discoverName}>{element.name}</div>}
                  {element?.description && <div className={styles.discoverDescription}>{element.description}</div>}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

DiscoverComponent.propTypes = {
  className: PropTypes.string,
  timelineIconClassName: PropTypes.string,
  descriptionClassName: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  elements: PropTypes.array,
};

export default DiscoverComponent;